import { Button, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import Iconify from 'src/components/iconify/Iconify';
import { Link as RouterLink, useParams, useSearchParams } from 'react-router-dom';
import history from 'src/history';
import SteLib from 'src/lib/stelib';
import moment from 'moment';

export default function CancelBookingPage() {
  const [firstTime, setFirstTime] = useState(true);
  const [step, setStep] = useState(0);
  const [bookingData, setBookingData] = useState({});
  const params = useParams();

  useEffect(() => {
    if(firstTime)
    {
      let proceed = false;
      
      if(params.token !== null)
      {
          SteLib.GetRequest("seatbookings/check_token/"+params.token, {}, true).then((data) => {
            setBookingData(data)
          });
      }
      if(!proceed)
      {
        //window.location.href = `${process.env.PUBLIC_URL}/`
      }
    }
    setFirstTime(false);
  }, [firstTime]);

  let confirmCancel = () => {
    SteLib.PutRequest("seatbookings/cancel/"+params.token, {}, true).then((data) => {
      setStep(1);
    });
  }

  return (    
    <div style={{width: "100%", margin: "auto", textAlign: "center"}}>
      {step === 0 ?
      <>
        <Stack>
        <h4>Ciao {bookingData.name} {bookingData.surname}<br/>Sei proprio sicuro di voler cancellare la tua prenotazione?</h4><br/>
        <span>Titolo: <b>{bookingData.title}</b><br/></span>
        <span>Data: <b>{moment(bookingData.dateTime, "YYYY-MM-DD HH:mm:ss").format("dddd DD/MM/YYYY HH:MM")}</b></span>
        <span>Posti: <b>{bookingData.seats}</b><br/></span>
        <br/>
        </Stack>
        <Button variant='contained' onClick={confirmCancel}>Conferma</Button>
      </> : 
      <>
        <Stack spacing={3} alignItems="center">
          <h3>Cancellazione Effettuata!</h3>
          <Iconify icon={'noto:party-popper'} style={{marginTop: ".5rem", width: "7rem",height: "7rem"}}></Iconify>
          <br/>
          <p>Ci dispiace che tu abbia disdetto, a presto!</p>
          <br/><br/><br/>
          <Button to={`${process.env.PUBLIC_URL}/`} size="large" variant="contained" component={RouterLink}>
            Torna alle Proiezioni
          </Button>
        </Stack>
      </>}
    </div>)
}


